import React from 'react';
import { ControlsContainer } from '../ControlsContainer';
import { PipelineControlsProps } from './PipelineControls.types';
import './PipelineControls.styles.css';

export const PipelineControls: React.FC<PipelineControlsProps> = ({
  searchQuery,
  onSearchChange,
  sortBy,
  onSortChange,
  sortOrder,
  onSortOrderChange,
  sortOptions,
  activeFilter,
  onFilterChange,
  filterOptions,
  showFilters = true,
  resultsCount,
  searchPlaceholder = 'Rechercher dans les expertises...',
  className = '',
  children
}) => {
  return (
    <div className={`pipeline-controls-wrapper ${className}`}>
      <ControlsContainer
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        sortBy={sortBy}
        onSortChange={onSortChange}
        sortOrder={sortOrder}
        onSortOrderChange={onSortOrderChange}
        sortOptions={sortOptions}
        activeFilter={activeFilter}
        onFilterChange={onFilterChange}
        filterOptions={filterOptions}
        showFilters={showFilters}
        resultsCount={resultsCount}
        searchPlaceholder={searchPlaceholder}
        className="pipeline-controls"
      />
      {children}
    </div>
  );
};